import React from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    // This boundary is inner to the root <Sentry.ErrorBoundary> and does not
    // re-throw, so the per-page render crashes it catches (e.g. the channel
    // editor) would otherwise never reach Sentry. Report them explicitly.
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-10 text-center">
          <h2>We hit an unexpected error.</h2>
          <p className="text-gray-500 mt-2">
            This page encountered a problem. Try refreshing, or go back to the{" "}
            <a href="/" className="text-blue-600 underline">home page</a>.
            If this keeps happening, please contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-6 py-2 cursor-pointer border border-gray-300 rounded bg-white"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
